import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ViajeZEDto;
type Column = kea.Grid2Column<Entity>;

const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    // { title: "Status", cell: x => ({ data: models.StatusViajeEAD[x.Status] }) },
    { title: "Proveedor", cell:  x=> ({ data: x.NombreProveedorZE }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChoferZE }) },
    { title: "Vehículo", cell: x => ({ data: x.NombreVehiculoZE }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Fecha inicio", cell: x => ({ data: kea.toDate(x.FechaInicio) }) },
    { title: "Fecha finalizó", cell: x => ({ data: kea.toDate(x.FechaFinalizo) }) },
    { title: "Estatus", cell: x => ({ data: models.StatusViajeZE[x.Status] }) },
    // { title: "Fecha llegada", cell: x => ({ data: kea.toDate(x.FechaLlegadaPendienteDescarga) }) },
    { title: "Fecha cancelación", cell: x => ({ data: kea.toDate(x.FechaCancelacion) }) },
    // { title: "Ruta", cell: x => ({ data: x.NombreRuta }) },
    
    { title: "Usuario capturó", cell: x => ({ data: x.NombreUsuario }) },
    // { title: "Usuario App", cell: x => ({ data: x.NombreUsuarioApp }) },
];

export interface BotonesDeps {
    onDarLlegada: (x: Entity) => void;
    onDarIniciar: (x: Entity) => void;
    onIniciarApp: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onVer: (x: Entity) => void;

    onTimbrarCartaPorte: (x: Entity) => void;
    onImprimirCartaPorte: (x: Entity) => void;
}

function botones(deps: BotonesDeps, permisos: models.Rol, HabilitarValidacionesCartaPorte:boolean): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            iconClass: fa("mobile"),
            onClick: deps.onIniciarApp,
            tooltip: "Cargar viaje a móvil",
            disabled: x => !permisos.ZonaExtendida.IniciarViajeZEApp
        },
        {
            iconClass: fa("arrow-right"),
            onClick: deps.onDarIniciar,
            tooltip: "Dar salida a viaje",
            disabled: x => !permisos.ZonaExtendida.VerBotonDarIniciarViajeZE 
            || 
            HabilitarValidacionesCartaPorte ? 
            !( x.TieneXmlTimbrado && x.TienexmlImpreso ) : false,
        }, {
            iconClass: fa("times"),
            onClick: deps.onCancelar,
            tooltip: "Cancelar",
            disabled: x => !permisos.ZonaExtendida.VerBotonCancelarViajeZE || x.TieneXmlTimbrado
        }, {
            iconClass: fa("eye"),
            onClick: deps.onVer,
            tooltip: "Ver",
            disabled: x => !permisos.ZonaExtendida.ObtenerDatosViajeZEApp
        }, {
            iconClass: fa("bell"),
            tooltip: "Timbrar Carta Porte",
            style: "default",
            onClick: deps.onTimbrarCartaPorte,
            //disabled: x => x.Status != models.StatusViajeZE.Creado && x.Status != models.StatusViajeZE.IniciadoApp ,
        },{
            iconClass: fa("print"),
            tooltip: "Imprimir carta porte timbrada",
            style: "default",
            onClick: deps.onImprimirCartaPorte,
            disabled: x => !x.TieneXmlTimbrado,
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "350px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol, HabilitarValidacionesCartaPorte:boolean ): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps, permisos,HabilitarValidacionesCartaPorte), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/list/columns.tsx